import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faCalendar, faUsers, faUserTie, faCalendarAlt, faTrophy, faBuilding, faMedal, faDollarSign, faCog, faTimes, faStar } from '@fortawesome/free-solid-svg-icons';

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
    const location = useLocation();

    const getLinkClass = (path) => {
        return location.pathname === path
            ? "flex items-center px-4 py-3 rounded-lg bg-brand-lime text-brand-dark font-medium cursor-pointer"
            : "flex items-center px-4 py-3 rounded-lg text-gray-300 hover:bg-brand-gray hover:text-white transition cursor-pointer";
    };

    return (
        <aside id="sidebar" className={`w-64 bg-brand-dark text-white min-h-screen fixed left-0 top-0 z-40 transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 transition-transform duration-300 ease-in-out`}>
            <div id="sidebar-header" className="p-6 border-b border-brand-gray flex justify-between items-center">
                <Link to="/">
                    <div>
                        <h1 className="text-2xl font-extrabold text-brand-lime tracking-tighter">5.AM</h1>
                        <span className="text-lg font-semibold">PADEL CLUB VISION</span>
                    </div>
                </Link>
                <button onClick={toggleSidebar} className="lg:hidden text-gray-400 hover:text-white">
                    <FontAwesomeIcon icon={faTimes} className="text-xl" />
                </button>
            </div>

            <nav id="sidebar-nav" className="mt-6">
                <div className="px-6 mb-4">
                    <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Utama</h3>
                </div>
                <ul className="space-y-2 px-4">
                    <li>
                        <Link to="/dashboard" className={getLinkClass('/dashboard')}>
                            <FontAwesomeIcon icon={faChartLine} className="mr-3" />
                            Dasbor
                        </Link>
                    </li>
                    <li>
                        <span className="flex items-center px-4 py-3 rounded-lg text-gray-300 hover:bg-brand-gray hover:text-white transition cursor-pointer">
                            <FontAwesomeIcon icon={faCalendar} className="mr-3" />
                            Pemesanan
                        </span>
                    </li>
                    <li>
                        <Link to="/members" className={getLinkClass('/members')}>
                            <FontAwesomeIcon icon={faUsers} className="mr-3" />
                            Anggota
                        </Link>
                    </li>
                    <li>
                        <span className="flex items-center px-4 py-3 rounded-lg text-gray-300 hover:bg-brand-gray hover:text-white transition cursor-pointer">
                            <FontAwesomeIcon icon={faStar} className="mr-3" />
                            Peringkat
                        </span>
                    </li>
                </ul>

                <div className="px-6 mt-8 mb-4">
                    <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Manajemen</h3>
                </div>
                <ul className="space-y-2 px-4">
                    <li>
                        <span className="flex items-center px-4 py-3 rounded-lg text-gray-300 hover:bg-brand-gray hover:text-white transition cursor-pointer">
                            <FontAwesomeIcon icon={faBuilding} className="mr-3" />
                            Lapangan
                        </span>
                    </li>
                    <li>
                        <Link to="/coaches" className={getLinkClass('/coaches')}>
                            <FontAwesomeIcon icon={faUserTie} className="mr-3" />
                            Pelatih
                        </Link>
                    </li>
                    <li>
                        <span className="flex items-center px-4 py-3 rounded-lg text-gray-300 hover:bg-brand-gray hover:text-white transition cursor-pointer">
                            <FontAwesomeIcon icon={faMedal} className="mr-3" />
                            Turnamen
                        </span>
                    </li>
                    <li>
                        <span className="flex items-center px-4 py-3 rounded-lg text-gray-300 hover:bg-brand-gray hover:text-white transition cursor-pointer">
                            <FontAwesomeIcon icon={faDollarSign} className="mr-3" />
                            Pembayaran
                        </span>
                    </li>
                    <li>
                        <span className="flex items-center px-4 py-3 rounded-lg text-gray-300 hover:bg-brand-gray hover:text-white transition cursor-pointer">
                            <FontAwesomeIcon icon={faCog} className="mr-3" />
                            Pengaturan
                        </span>
                    </li>
                </ul>
            </nav>
        </aside>
    );
};

export default Sidebar;